import { ceil } from 'lodash';
import React, { useRef, useState, useEffect } from 'react';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';

const BrandForm = ({
    create_new=false,
    brand_Name= "",
    brand_Field= "",
    brand_Options=  [],
    brand_DefaultValue= [],
    brand_Mybrand= false,
    brand_Order= null,
    sub_brand_Field = "",
    sub_brand_Options = {},
    sub_brand_DefaultValue = []
}) => {

    const BRAND_DEFAULT_OPTIONS_PAGE_SIZE=100
    const BRAND_DEFAULT_OPTIONS_PAGE_STEP=90
    const MAX_BRAND_DEFAULT_OPTIONS_PAGE = ceil((brand_Options.length-BRAND_DEFAULT_OPTIONS_PAGE_SIZE) / BRAND_DEFAULT_OPTIONS_PAGE_STEP)
    
    const [brandDefaultOptionsPage, setBrandDefaultOptionsPage] = useState(0)
    
    const [currentBrand, setCurrentBrand] = useState(brand_DefaultValue[0])
    const [currentSubBrands, setCurrentSubBrands] = useState(sub_brand_DefaultValue)
    const subBrandRef = useRef(null)

    useEffect(() => {
        var subBrandfieldInput = document.getElementById(sub_brand_Field)
        subBrandfieldInput.value = JSON.stringify(currentSubBrands.map((v => v['value'])))
    }, [currentSubBrands])

    useEffect(() => {
        var brandfieldInput = document.getElementById(brand_Field)
        brandfieldInput.value = currentBrand['value']

    }, [currentBrand])

    const filterOptions = (inputValue="", options) => {

        return new Promise((resolve, reject) => {
            setTimeout(() => {
                if (inputValue == "") {
                    resolve(options);
                }
                else {
                    const foundItem = options.filter(option => option.label.toLowerCase().startsWith(inputValue.toLowerCase()));
                    if (foundItem !== undefined) {
                        resolve(foundItem);
                    } else {
                        reject(null);
                    }
                }

                
              }, 1000);
        })
    };

    function arrSlice(page, arr) {
        let startingIndex=page*BRAND_DEFAULT_OPTIONS_PAGE_STEP
        let endingIndex = startingIndex+BRAND_DEFAULT_OPTIONS_PAGE_SIZE
        endingIndex = (endingIndex > arr.length)? arr.length:endingIndex

        return arr.slice(startingIndex, endingIndex)
    }

    return (
        <>
            <div className="field">
                <div className="px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <div className="text-md font-medium text-gray-500">      
                        <div>     
                            <span className="p-2 flex-1 w-0 break-all w-full ">Brand</span>
                        </div>
                    </div>
                    <div className="mt-1 text-md text-gray-900 sm:mt-0 sm:col-span-2">
                        {
                        (create_new)?
                            <div>
                                <AsyncSelect
                                    defaultValue={brand_DefaultValue}
                                    isMulti={false}
                                    onChange={(value) => {
                                        setCurrentBrand(value)
                                        subBrandRef.current.state.value = []
                                        var brandfieldInput = document.getElementById(brand_Field)
                                        brandfieldInput.value = value['value']
                                    }}
                                    defaultOptions={
                                        arrSlice(brandDefaultOptionsPage, brand_Options)
                                    }
                                    cacheOptions={true}
                                    loadOptions={
                                        (inputValue,callback) => { 
                                            filterOptions(inputValue, brand_Options)
                                            .then((resolve, reject) => {
                                                callback(resolve)
                                            })
                                        }
                                    }

                                    onMenuScrollToBottom={
                                        (e) => {
                                            const eventParentNode = e.target.parentNode

                                            function handleWheel(event) {
                                                if (event.wheelDeltaY < -155) {
                                                    setTimeout(() => {
                                                        setBrandDefaultOptionsPage(
                                                            (prevPage) => {
                                                                if (prevPage < MAX_BRAND_DEFAULT_OPTIONS_PAGE) {
                                                                    eventParentNode.scrollTop=0
                                                                    return prevPage+1
                                                                }
                                                                return prevPage
                                                            }
                                                        )
                                                    }, 1000);
                                                    eventParentNode.removeEventListener("wheel", handleWheel);
                                                }
                                            }
                                            eventParentNode.addEventListener("wheel", handleWheel)
                                        }                                        
                                    }

                
                                    onMenuScrollToTop={
                                        (e) => {
                                            const eventParentNode = e.target.parentNode
                                            function handleWheel(event) {
                                                if (event.wheelDeltaY > 155) {
                                                    setTimeout(() => {
                                                        setBrandDefaultOptionsPage(
                                                            (prevPage) => {
                                                                if (prevPage > 0) {
                                                                    eventParentNode.scrollTop=eventParentNode.scrollHeight
                                                                    return prevPage-1
                                                                }
                                                                return prevPage
                                                            }
                                                        )
                                                    }, 1000);
                                                    eventParentNode.removeEventListener("wheel", handleWheel);
                                                }
                                            }
                                            eventParentNode.addEventListener("wheel", handleWheel)
                                        }
                                    }
                                />
                            </div>
                            :
                            <span>{brand_Name}</span>
                        }
                    </div>
                </div>
            </div>
            <div className="field">
                <div className="px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <div className="text-md font-medium text-gray-500">    
                        <div>
                            <span className="p-2 flex-1 w-0 break-all w-full ">Sub Brands</span>
                        </div>
                    </div>
                    <div className="mt-1 text-md text-gray-900 sm:mt-0 sm:col-span-2">
                        <Select
                            ref={subBrandRef}
                            defaultValue={sub_brand_DefaultValue}
                            isMulti={true}
                            options={(currentBrand['label'] in sub_brand_Options)? sub_brand_Options[currentBrand['label']]:[]}
                            onChange={(value) => {
                                setCurrentSubBrands(value)
                            }}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default BrandForm;